import { smoothScrollTo, easings, EasingKey } from "./smooth-scroll";

type AnchorScrollOptions = {
  isReducedMotion?: boolean;
  additionalOffset?: number;
  updateUrl?: boolean;
  duration?: number;
  easing?: EasingKey;
};

export const anchorScroll = (href: string, options?: AnchorScrollOptions) => {
  if (!href.includes("#")) return;

  const hashIndex = href.indexOf("#");
  const targetId = href.substring(hashIndex);

  // Guard against malformed hrefs like "page#"
  if (targetId.length <= 1) return;

  const targetElement = document.getElementById(targetId.slice(1));

  if (!targetElement) return;

  if (options?.updateUrl) {
    history.pushState(null, "", `${targetId}`);
  }

  const targetElementOffsetTop = targetElement.getBoundingClientRect().top;
  const scrollMarginTop =
    parseInt(getComputedStyle(targetElement).scrollMarginTop) || 0;

  smoothScrollTo({
    to: {
      top:
        (targetElementOffsetTop ?? 0) +
        window.scrollY -
        (scrollMarginTop + (options?.additionalOffset ?? 0)),
      left: 0,
    },
    duration: options?.duration ?? 1500,
    easing: easings[options?.easing ?? "easeInOutQuart"],
    isReducedMotion: options?.isReducedMotion ?? false,
  });
};
